import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.049 1.871c.384.018.714.17.964.305.293.16.642.392 1.029.65l10.516 7.011c.317.212.613.407.838.589.227.183.495.437.649.807a2 2 0 0 1 0 1.533c-.154.37-.422.625-.649.808-.225.182-.52.377-.838.59l-10.516 7.01c-.387.258-.736.491-1.03.65-.284.155-.675.331-1.131.304a2 2 0 0 1-1.476-.79c-.276-.365-.346-.788-.376-1.11C5 19.895 5 19.476 5 19.01V4.989c0-.465-.001-.884.03-1.216.029-.323.1-.746.375-1.11a2 2 0 0 1 1.476-.79zM7 19.011c0 .505.001.814.021 1.034l.005.036.035-.015c.193-.106.452-.276.872-.556l10.515-7.01c.35-.234.555-.372.693-.483l.018-.018-.018-.017a11 11 0 0 0-.693-.48L7.933 4.49c-.42-.28-.678-.451-.872-.556q-.018-.01-.035-.017-.001.018-.005.038c-.02.22-.021.53-.021 1.034z"
}));
export default SvgPlay;
//# sourceMappingURL=Play.js.map